<template>
  <div>
    <AppLoader v-if="isLoading" class="text-center" small />
    <b-container fluid class="m-0" v-if="!isLoading">
      <b-row v-if="showingIntro && !complaintViewPage && form.isShowFormIntro">
        <b-col cols="8" offset="2">
          <div class="align-middle my-5">
            <h3>{{form.formTitle ? form.formTitle[selectedLanguage || 'english'] : 'No Title'}}</h3>
            <div style="height:calc(100vh - 275px);overflow:auto;">
              <p v-html="sanitizeHtml(form.formIntroText ? form.formIntroText[selectedLanguage|| 'english'] : 'No Title')"></p>
            </div>

            <b-form-checkbox
              class="text-center my-3"
              v-model="userConsent"
            >{{$t('questionnaires.consent')}}</b-form-checkbox>
            <b-button
              variant="outline-danger"
              class="mr-2"
              to="/dashboard"
            >{{$t('questionnaires.backToDashboard')}}</b-button>
            <b-button
              variant="outline-success"
              :disabled="!userConsent"
              class="mr-2"
              @click="onClickProceed()"
            >{{$t('questionnaires.proceed')}}</b-button>
          </div>
        </b-col>
      </b-row>
      <b-row v-else>
        <b-col :cols="complaintViewPage ? '12' : '10'" :offset="complaintViewPage ? '' : '1'">
          <b-card>
            <div style="overflow:hidden;">
              <b-row>
                <b-col class="text-center">
                  <h3
                    class="mt-2"
                  >{{form.formTitle ? form.formTitle[selectedLanguage || 'english'] : 'No Title'}}</h3>
                  <p>{{form.formDescription ? form.formDescription[selectedLanguage || 'english'] : 'No Description'}}</p>
                </b-col>
              </b-row>

              <div id="scrollspy" class="preview-scrollable-wrapper p-3">
                <div v-if="form.formSection.length" id="element" style="background-color:#F4F4F4;">
                  <b-form v-if="!isLoading">
                    <SectionContainer
                      v-for="(sectionData, index) in form.formSection"
                      :id="'section_'+index"
                      :isDisabled="isDisabled"
                      :isPreview="true"
                      :selectedLanguage="selectedLanguage"
                      :sectionData="sectionData"
                      :inputType="sectionData.inputType"
                      :key="index"
                      :counter="index"
                    />
                  </b-form>
                </div>
              </div>
              <b-row class="mt-3">
                <b-col cols="6" class="text-left">
                  <a
                    v-if="form.formSection.length"
                    href="#"
                    class="goto-top-btn btn"
                    v-scroll-to="{
                  el: '#scrollspy',
                  container: '#scrollspy',
                  duration: 300,
                  easing: 'linear',
                  
                  force: true,
                  
                  x: false,
                  y: true
                }"
                  >
                    <font-awesome-icon icon="angle-up" />
                  </a>
                </b-col>

                <b-col>
                  <b-button-group class="float-right">
                    <b-button
                      v-if="form.formSection.length && taskStatus !=4 && !complaintViewPage"
                      variant="outline-success"
                      @click="onValidateSubmit"
                    >{{$t('submitText')}}</b-button>
                  </b-button-group>
                </b-col>
              </b-row>
            </div>
          </b-card>
        </b-col>
      </b-row>

      <!-- review modal -->
      <b-modal
        id="modal-1"
        modal-header-close="No"
        :ok-title="$t('submitText')"
        :cancel-title="$t('cancelBtnText')"
        hide-header-close
        no-close-on-esc
        no-close-on-backdrop
        :title="$t('questionnaires.submitModalTitle')"
        @ok="onSubmit"
      >
        <p>{{$t('formSubmitingMessage')}}</p>
        <p></p>
      </b-modal>

      <b-modal
        title="Upload File (optional)"
        v-model="showUploadModal"
        size="lg"
        scrollable
        no-close-on-backdrop
        no-close-on-esc
        hide-header-close
      >
        <div>
          <div class="text-center" v-if="!submiting && !responseSuccess">
            <p>To serve you better, kindly upload screenshots or documents that can help us identify and resolve your issue faster.</p>
            <vue-dropzone
              ref="myVueDropzone"
              id="dropzone"
              v-on:vdropzone-sending="sendingEvent"
              @vdropzone-success="vsuccess"
              :options="dropzoneOptions"
              :useCustomSlot="true"
              class="m-5 p-3"
              style="border:dashed 1px"
            >
              <div class="dropzone-custom-content">
                <h3 class="dropzone-custom-title">Drag and drop to upload content!</h3>
                <div class="subtitle">...or click to select a file from your computer</div>
              </div>
            </vue-dropzone>
            <b-form-group label-cols-sm="4" label-cols-lg="3" label="Display Name">
              <b-form-input type="text" v-model="uploadFileDisplayName" size="sm" />
            </b-form-group>
          </div>
          <div v-else-if="submiting && !responseSuccess">
            <p>Your File is being Uploading......</p>
            <b-spinner type="grow" label="Loading..."></b-spinner>
          </div>
          <div v-else>
            <p class="my-2 text-center">
              Your File has been uploaded successfully.
              <br />
            </p>
          </div>
        </div>
        <template v-slot:modal-footer>
          <div class="float-right">
            <b-button
              class="mr-3"
              variant="outline-danger"
              v-if="!uploading"
              @click="skipUploadFiles"
            >Skip</b-button>
            <b-button
              variant="outline-success"
              v-if="!uploading && !responseSuccess"
              @click="uploadFileApiCall"
            >Upload</b-button>
          </div>
        </template>
      </b-modal>

      <b-modal
        id="modal-2"
        modal-header-close="No"
        ok-only
        :ok-title="$t('closeBtnText')"
        hide-header-close
        no-close-on-esc
        no-close-on-backdrop
        :title="$t('questionnaires.formSubmittedModalTitle')"
        @ok="openDashboardPage"
      >
        <p>{{$t('formSubmittedMessage')}}</p>
        <p></p>
      </b-modal>

      <b-alert
        v-model="showErrorToast"
        class="position-fixed fixed-top m-0 rounded-0"
        style="z-index: 2000;"
        variant="danger"
        dismissible
        solid
      >{{$t('formValidationMessage')}}</b-alert>
    </b-container>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations, mapState } from "vuex";
import { sanitizeHtml } from "@/utils/sanitizeHtml";
import SectionContainer from "../../containers/SectionUserContainer";
import AppLoader from "../../components/Loader/Loader";
import { EventBus } from "@/event-bus.js";
import { HTTP } from "../../utils/HTTP";
import _ from "lodash";
import "vue2-dropzone/dist/vue2Dropzone.min.css";
import VueDropzone from "../../components/Dropzone/VueDropzone";

export default {
  name: "EmployeeComplaintForm",
  components: {
    SectionContainer,
    AppLoader,
    VueDropzone,
  },
  data() {
    return {
      submiting: false,
      responseSuccess: false,
      uploading: false,
      showUploadModal: false,
      dropzoneOptions: {
        url: "",
        thumbnailWidth: 150,
        maxFilesize: 25,
        addRemoveLinks: true,
        autoProcessQueue: false,
        headers: {
          Authorization: "Bearer " + localStorage.getItem("accessToken"),
        },
      },
      uploadFileDisplayName: null,
      isDisabled: 0,
      enabled: true,
      dragging: false,
      selected: "english",
      isInvalid: false,
      pageIntroText: "",
      showingIntro: true,
      showErrorToast: false,
      currentSectionIndex: 0,
      taskStatus: null,
      userConsent: 0,
      taskAssignedDate: null,
      taskCompletedDate: null,
      taskId: null,
      taskFiles: [],
      fromButton: false,
      isLoadingLocal: false,
      inValidElements: [],
      inValidSections: [],
      pageStatus: null,
      isAnonymous: null,
      complaintType: null,
      commentValue: null,
    };
  },

  mounted() {
    this.$store.state.employeeDashboardTabIndex = 2;
    this.$store.state.validFields = true;
    let form_data = [];
    if (this.complaintViewPage == true) {
      form_data = this.formData;
      this.isDisabled = 1;
      this.getTaskForm(form_data);
    } else {
      this.getTaskForm(form_data);
    }
  },

  beforeDestroy() {},

  beforeRouteLeave(to, from, next) {
    if (
      this.$route.name == "userform" ||
      this.$route.name == "EmployeeComplaintFormPage"
    ) {
      if (this.fromButton) {
        next();
      } else {
        const answer = window.confirm(this.$t("formLeaveAlertMessage"));
        if (answer) {
          this.$store.state.userFormSubmitArray = [];
          this.$store.state.getUserFormSubmitArray = [];
          this.onResetLocalData();
          next();
        } else {
          next(false);
        }
      }
    } else {
      next();
    }
  },

  computed: {
    ...mapGetters({
      form: "form1",
      selectedLanguage: "selectedLanguage",
      isLoading: "isLoading",
    }),

    ...mapState({
      userFormSubmitArray: "userFormSubmitArray",
      form: "form1",
      validFields: "validFields",
      rightAlign: "rightAlign",
      progressValue: "progressValue",
      progressMaxValue: "progressMaxValue",
    }),
  },

  watch: {
    selectedLanguage(lang) {
      this.updateTitles(lang);
    },
  },

  methods: {
    sanitizeHtml,
    ...mapActions(["setLanguage"]),
    ...mapMutations(["TOGGLE_LOADER"]),
    ...mapMutations(["UPDATE_FORM"]),

    makeToast() {
      const h = this.$createElement;
      const vNodesMsg = h("p", { class: ["text-center", "mb-0"] }, [
        h("b-spinner", { props: { type: "grow", small: true } }),
        this.$t("toast.generatePDF"),
        h("b-spinner", { props: { type: "grow", small: true } }),
      ]);
      this.$bvToast.toast([vNodesMsg], {
        variant: "warning",
        title: "PDF",
        autoHideDelay: 5000,
      });
    },

    onClickProceed() {
      this.showingIntro = false;
    },

    onResetLocalData() {
      localStorage.removeItem("taskId");
      localStorage.removeItem("examAttemptsToDate");
      localStorage.removeItem("activeTaskStatus");
      localStorage.removeItem("activeFormSchema");
      localStorage.removeItem("examAttemptsToDate");
      localStorage.removeItem("examAttemptId");
      localStorage.removeItem("tempForm");
      localStorage.removeItem("activeFormId");
      localStorage.removeItem("userConsent");
      this.$store.state.registerData = {};
      this.$store.state.progressValue = 0;
      this.$store.state.progressMaxValue = 0;
    },

    initializeFormData() {
      this.$store.state.progressMaxValue = 0;
      if (
        this.$store.state.getUserFormSubmitArray &&
        this.$store.state.getUserFormSubmitArray.length
      ) {
        this.$store.state.userFormSubmitArray = this.$store.state.getUserFormSubmitArray;
        this.$store.state.progressMaxValue = this.$store.state.getUserFormSubmitArray.length;
        this.calculateProgressValue(this.$store.state.getUserFormSubmitArray);
      } else {
        this.$store.state.userFormSubmitArray = [];
        let tempForm = _.cloneDeep(this.form);
        tempForm.formSection.map((section, index) => {
          section.formElements.map((element, elementIndex) => {
            this.$store.state.progressMaxValue += 1;
            this.$store.state.userFormSubmitArray.push({
              elements: [],
              sectionId: section.id,
              sectionIndex: section.index,
              elementIndex: elementIndex,
              elementId: element.id,
              elementInputType: element.inputType,
              elementTitle: element.label,
              elementTitleAbb: element.label,
              sectionTitle: section.abbreviationLabel || element.label,
              language: this.selectedLanguage,
              isMultiSelect: 0,
              selectedChart: element.selectedCharts || null,
              enableSelfReporting:
                (element.configuration &&
                  parseInt(element.configuration.enableSelfReporting)) ||
                0,
            });
          });
        });
      }
    },

    updateTitles(lang) {
      const dd = this.$store.state.userFormSubmitArray;
      let array2 = dd.map((a) => {
        return (a.language = lang);
      });
    },

    calculateProgressValue(array) {
      const registerData = _.clone(this.$store.state.registerData);
      for (let i = 0; i < array.length; i++) {
        if (array[i].elements.length > 0 && array[i].elements[0].postValue) {
          registerData[array[i].elementId] = array[i].elementId;
        }
        if (
          array[i].elements.length > 0 &&
          array[i].elements[0].postValue &&
          array[i].elements[0].postValue.length
        ) {
          registerData[array[i].elementId] = array[i].elementId;
        }
        if (
          array[i].elements.length > 0 &&
          array[i].elements[0].length &&
          array[i].elements[0][0].postValue
        ) {
          registerData[array[i].elementId] = array[i].elementId;
        }
        if (
          array[i].elements.length > 0 &&
          array[i].elements[0].postValue &&
          array[i].elements[0].postValue.phone
        ) {
          registerData[array[i].elementId] = array[i].elementId;
        }
      }
      this.$store.state.registerData = registerData;
      let numkeys = Object.keys(registerData).length;
      this.$store.state.progressValue = numkeys;
    },

    changeLanguage() {
      let tt = this.selected.toLowerCase();
      this.setLanguage(tt);
      this.TOGGLE_LOADER(100);
    },

    setUserFormSchemaToStore() {
      let form = JSON.parse(localStorage.getItem("activeFormSchema"));
      let taskdata = JSON.parse(localStorage.getItem("taskFormData"));
      this.updateFormToStore(form);
    },

    updateFormToStore(form) {
      this.UPDATE_FORM(form);
    },

    onValidateSubmit() {
      EventBus.$emit("onSubmitEndUserForm", "form submit");
      this.getInvalidFields();
      this.checkForInValidFields();
    },

    openDashboardPage() {
      this.$router.push("/dashboard");
    },

    checkForInValidFields() {
      let isValid = false;
      outerLoop: for (
        let i = 0;
        i < this.$store.state.form1.formSection.length;
        i++
      ) {
        for (
          let x = 0;
          x < this.$store.state.form1.formSection[i].formElements.length;
          x++
        ) {
          if (
            this.$store.state.form1.formSection[i].formElements[x].isInValid
          ) {
            let inValidData = {
              elementId: this.$store.state.form1.formSection[i].formElements[x]
                .id,
              sectionId: this.$store.state.form1.formSection[i].id,
            };
            EventBus.$emit("OnInvalidFieldCatch", inValidData);
            this.showErrorToast = true;
            isValid = false;
            break outerLoop;
          }
          isValid = true;
        }
      }
      if (isValid) {
        this.onReviewSubmit();
      }
    },

    getInvalidFields() {
      this.inValidElements = [];
      this.inValidSections = [];
      for (let i = 0; i < this.$store.state.form1.formSection.length; i++) {
        for (
          let x = 0;
          x < this.$store.state.form1.formSection[i].formElements.length;
          x++
        ) {
          if (
            this.$store.state.form1.formSection[i].formElements[x].isInValid
          ) {
            this.inValidElements.push(
              this.$store.state.form1.formSection[i].formElements[x]
            );
          }
        }
      }
    },

    onReviewSubmit() {
      if (this.$store.state.validFields) {
        this.showErrorToast = false;
        this.$bvModal.show("modal-1");
      } else {
        this.showErrorToast = true;
      }
    },

    async onSubmit() {
      let form_data = this.$store.state.userFormSubmitArray;
      form_data.map((elementsData) => {
        if (
          elementsData.elementTitle.english ==
          "Do you wish to have your details remain confidential?"
        ) {
          elementsData.elements.map((element) => {
            this.isAnonymous = element.postValue == "Yes" ? 1 : 0;
          });
        }
        if (elementsData.elementTitle.english == "Type of Complaint") {
          elementsData.elements.map((element) => {
            this.complaintType = element.postValue[0];
          });
        }
        if (
          elementsData.elementTitle.english ==
          "Please provide a detailed explanation of the complaint:"
        ) {
          elementsData.elements.map((element) => {
            this.commentValue = element.postValue;
          });
        }
      });
      await this.saveFormData();
    },

    async saveFormData() {
      let taskData = this.$store.state.userFormSubmitArray;
      let token = "Bearer " + localStorage.getItem("accessToken");
      try {
        let result = await HTTP(
          "post",
          "api/v1/complaints/create",
          {
            form_data: taskData,
            complaint_type: this.complaintType,
            comment: this.commentValue,
            is_anonymous: this.isAnonymous,
            user_id: localStorage.getItem("userId"),
          },
          {
            Authorization: token,
          },
          null,
          true
        );
        if (result) {
          this.dropzoneOptions.url =
            process.env.VUE_APP_API_URL +
            "api/v1/complaints/files/upload/" +
            result.data.complaints.id;
          this.showUploadModal = true;
        }
      } catch {
        this.fromButton = true;
        this.$bvModal.show("modal-2");
      }
    },

    onScrollClick(index) {
      let id = "section_" + index;
      this.currentSectionIndex = index;
      document.getElementById(id).scrollIntoView({ behavior: "smooth" });
    },

    async getTaskForm(form_data) {
      localStorage.removeItem("activeFormSchema");
      let token = "Bearer " + localStorage.getItem("accessToken");
      let result = await HTTP(
        "post",
        "api/v1/forms/list",
        {
          type: "complaint",
        },
        {
          Authorization: token,
        },
        null,
        true
      );
      if (result.data.form) {
        let form_schema = result.data.form.schema;
        this.form = form_schema;
        if (form_data.length) {
          this.$store.state.getUserFormSubmitArray = form_data;
        }
        localStorage.setItem("activeFormSchema", form_schema);
        this.setUserFormSchemaToStore();
        this.initializeFormData();
      }
    },
    uploadFileApiCall() {
      if (this.$refs.myVueDropzone.getQueuedFiles().length > 0) {
        this.uploading = true;
        this.$refs.myVueDropzone.processQueue();
      }
    },
    vsuccess() {
      this.uploading = false;
      this.submiting = false;
      this.responseSuccess = true;
      this.$bvToast.toast(
        "Your file has been successfully uploaded and is now processed",
        {
          title: "File Upload is complete",
          noAutoHide: false,
          appendToast: true,
        }
      );
      this.$refs.myVueDropzone.removeAllFiles();
      this.resetUploadModal();
      this.fromButton = true;
      this.$bvModal.show("modal-2");
    },
    sendingEvent(file, xhr, formData) {
      formData.append("employee_id", localStorage.getItem("employeeId"));
      formData.append("displayName", this.uploadFileDisplayName);
      formData.append("user_id", localStorage.getItem("userId"));
    },
    resetUploadModal() {
      this.isLoadingComplaintsFiles = false;
      this.submiting = false;
      this.responseSuccess = false;
      this.showUploadModal = false;
    },
    skipUploadFiles() {
      this.isLoadingComplaintsFiles = false;
      this.submiting = false;
      this.responseSuccess = false;
      this.showUploadModal = false;
      this.$router.push("/dashboard");
    },
  },
  props: {
    complaintViewPage: Boolean,
    formData: Array,
  },
};
</script>

<style scoped>
@import "../../assets/styles/theme1/tabs.css";
@import "../../assets/styles/theme1/timeline.css";
.preview-scrollable-wrapper {
  position: relative;
  overflow-y: auto;
  height: calc(100vh - 285px);
  /* height:400px */
}
a.goto-top-btn {
  border-color: #3b3e66 !important;
  color: #3b3e66 !important;
  background-color: #fff;
}
a.goto-top-btn:hover {
  color: #fff !important;
  border-color: #3b3e66 !important;
  background-color: #3b3e66;
}
.selectPicket {
  width: 350px;
}
</style>

